<template>
  <SelectBox v-if="isMobile" icon="v" :name="vvName" :key="vvKey"
    label="Płeć*" :options="optionsForMobile" @input="input"
    :value="value" v-validate="{ rules: rules }" :validateAs="validateAs" />
  
  <InputBox v-else icon="v" :name="vvName" :key="vvKey"
    :highlight="highlight" :label="label" @click="$emit('click')"
    :value="selectedLabel" :validateAs="validateAs" v-validate="{ rules: rules }">
    <RadioList v-model="selected" v-if="highlight" :options="optionsForWeb"
      @input="input" @close="$emit('close')" />
  </InputBox>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import Vue from 'vue'
import Component from 'vue-class-component'

import RadioList from '@/components/search/fields/RadioListDropdown'
import InputBox from '@/components/search/InputBox'
import SelectBox from '@/components/search/SelectBox'
import MediaDetector from '@/utils/MediaDetector'

@Component({
  mixins: [
    MediaDetector,
  ],
  components: {
    InputBox,
    RadioList,
    SelectBox,
  },
  props: {
    value: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    highlight: {
      type: Boolean,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    vvKey: {
      type: String,
      required: true,
    },
    vvName: {
      type: String,
      required: true,
    },
    validateAs: {
      type: String,
      required: true,
    },
    rules: {
      type: String,
      required: true,
    },
  },
})
export default class RadioListInputBox extends Vue {
  selected = cloneDeep(this.value)

  get selectedLabel () {
    return this.getFormatedSelectValue(this.value, 'Wybierz')
  }

  get optionsForMobile () {
    return this.options.map(option => ({ value: option, text: this.formatListItem(option, 'Wybierz') }))
  }

  get optionsForWeb () {
    return this.options
      .map(option => ({ value: option, name: option, enabled: true }))
      .filter(option => option.name !== '')
  }

  input (value) {
    this.manualValidateChangedField(value)
    this.$emit('input', value)
  }

  manualValidateChangedField (value) {
    this.$validator.validate(this.validateAs, value)
    this.$validator.fields.find({ name: this.validateAs }).setFlags({ 'changed': true })
  }

  getFormatedSelectValue (item, label, max = 1) {
    if (item == null) return label
    else if (item.length === 0) return label
    else if (typeof item === 'string' && item !== '') return item
    else if (item.length <= max) return item.take(item.length).map(x => x.name).join(', ')
    else return `${item.length} wybrano`
  }

  formatListItem (item, defaultText = '') {
    if (item === '') return defaultText
    else return item
  }
}
</script>


// WEBPACK FOOTER //
// src/components/RadioListInputBox.vue